<template>
  <div class="page-user-lsit">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">會員管理</div>
      <div class="breadcrumb-item">會員列表</div>
    </div>

    <div class="card-block">
      <Form inline class="pg-form-inline" v-if="remarks == 1">
        <FormItem>
          <Select
            size="small"
            style="width: 120px"
            placeholder="提貨櫃點"
            v-model="form.store_id"
          >
            <Option
              :value="item.ReceivingID"
              v-for="(item, index) in pickAddress"
              :key="item.ReceivingID"
              >({{ item.cainiao_match }}) {{ item.ReceivingName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            :clearable="false"
            placeholder="用戶註冊起始日期"
            value-format="yyyy-MM-dd hh:mm:ss"
            style="width: 100%"
            v-model="form.start_time"
          ></DatePicker>
        </FormItem>

        <FormItem>-</FormItem>

        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            :clearable="false"
            placeholder="用戶註冊結束日期"
            value-format="yyyy-MM-dd hh:mm:ss"
            style="width: 100%"
            v-model="form.end_time"
          ></DatePicker>
        </FormItem>
      </Form>

      <Form inline class="pg-form-inline form-input-wrap">
        <FormItem>
          <label class="input-label">客戶名稱</label>
          <Input
            size="small"
            v-model="form.username"
            @keyup.enter.native="handleSearch()"
          />
        </FormItem>
        <FormItem>
          <label class="input-label">手機號碼</label>
          <Input
            size="small"
            v-model="form.phone"
            @keyup.enter.native="handleSearch()"
          />
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
            <!-- <div class="pg-btn style2">導出excel(開發中)</div> -->
          </div>
        </FormItem>
      </Form>
    </div>
    <Button
      type="primary"
      style="margin-bottom: 16px"
      @click="$router.push('/addUser')"
      >新增用户</Button
    >
    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <Table
        size="small"
        no-data-text="暫無數據"
        border
        :columns="table.column"
        :data="table.data"
      >
        <template slot-scope="{ row, index }" slot="avatar">
          <div class="avatar-box">
            <img :src="row.avatar" alt="" />
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div class="pg-btn-wrap">
            <div class="pg-btn style3" @click="handleIntegral(index)">
              積分操作
            </div>
            <template v-if="remarks == 1">
              <div class="pg-btn style2" @click="handleEdit(index)">
                編輯資料
              </div>
              <div
                class="pg-btn style1"
                @click="handleDelete(index, 1)"
                v-if="row.status == 0"
              >
                凍結賬戶
              </div>
              <div
                class="pg-btn style1"
                @click="handleDelete(index, 0)"
                v-else-if="row.status == 1"
                style="background: #03a9f4"
              >
                啟用賬戶
              </div>
            </template>
            <div
              class="pg-btn style1"
              style="margin-top: 6px"
              @click="handleDeleteWx(row)"
            >
              微信解绑
            </div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="12" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
          </Col>
          <Col span="12" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select
                  v-model="curPageSize"
                  size="small"
                  placeholder="數量"
                  @on-change="handlePageSizeChange"
                >
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input
                  size="small"
                  v-model="pageInput"
                  @on-keyup="handlePageInput"
                  @on-enter="handlePageEnter"
                />
              </div>

              <Page
                size="small"
                :current="pageIndex"
                :page-size="curPageSize"
                :total="totalCount"
                @on-change="handlePageChange"
              >
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Store from "../../../assets/js/store.js";

export default {
  data() {
    return {
      pageIndex: 1, //页码
      curPageSize: 10, //一页数量
      totalCount: 1, //总条数
      pageInput: "", //输入的页码
      remarks: Store.fetch().type,
      pickAddress: [], //提貨櫃點

      form: {
        store_id: "",
        start_time: "",
        end_time: "",
        username: "",
        phone: "",
      },

      isSubmiting: false,

      table: {
        column: [
          {
            title: "操作",
            slot: "action",
            align: "center",
            width: 270,
          },
          {
            title: "會員號碼",
            key: "user_id",
            align: "center",
            sortable: true,
            minWidth: 80,
          },
          {
            title: "用戶頭像",
            key: "avatar",
            slot: "avatar",
            align: "center",
            sortable: true,
            width: 80,
          },
          {
            title: "客戶名稱",
            key: "user_name",
            align: "center",
            sortable: true,
            width: 120,
          },
          {
            title: "聯絡電話",
            key: "phone",
            align: "center",
            sortable: true,
            minWidth: 120,
          },
          {
            title: "取貨櫃點",
            key: "cabinet_name",
            align: "center",
            sortable: true,
            width: 150,
          },
          {
            title: "充值積分",
            key: "user_integral",
            align: "center",
            sortable: true,
            minWidth: 80,
          },
          {
            title: "贈送積分",
            key: "user_integral_tw",
            align: "center",
            sortable: true,
            minWidth: 80,
          },
          {
            title: "集金幣",
            key: "jpoint",
            align: "center",
            sortable: true,
            minWidth: 80,
          },
          {
            title: "公眾號",
            key: "wx_openid",
            align: "center",
            sortable: true,
            width: 80,
          },
          {
            title: "推送CID",
            key: "cid",
            align: "center",
            sortable: true,
            width: 80,
          },
          {
            title: "註冊時間",
            key: "reg_time",
            align: "center",
            sortable: true,
            width: 160,
          },
          {
            title: "APP最後登入時間",
            key: "last_time",
            align: "center",
            sortable: true,
            width: 160,
          },
          {
            title: "最新版本號",
            key: "userversion",
            align: "center",
            sortable: true,
            width: 80,
          },
          {
            title: "最新版本號下載時間",
            key: "userversion_time",
            align: "center",
            sortable: true,
            width: 160,
          },
        ],
        data: [],
      },
    };
  },
  mounted() {
    this.getPickAddress();
    this.getList();
  },
  activated() {
    this.getPickAddress();
    this.getList();
  },
  methods: {
    handleDeleteWx(row) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否解绑</p>",
        onOk: () => {
          this.$Rq
            .requestAuth({
              url: this.$Api.delUserWx,
              method: "post",
              data: {
                user_id: row.user_id,
              },
            })
            .then((res) => {
              this.$message.success(res.msg);
            });
        },
        onCancel: () => {
          this.$Message.info("取消");
        },
      });
    },
    formatDate(datetime) {
      if (!datetime) return "";

      let dateTime = new Date(datetime);
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let date = dateTime.getDate();
      let hour = dateTime.getHours();
      let minute = dateTime.getMinutes();
      let second = dateTime.getSeconds();
      let milliseconds = dateTime.getMilliseconds();
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
        date
      )} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
        milliseconds
      )}`;
    },
    formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    getPickAddress() {
      //提貨櫃點
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress = res.data.data.filter(
              (it) => it.company_id != 15
            );
          }
        });
    },
    getList() {
      let form = this.form;
      this.isSubmiting = true;

      this.$Rq
        .requestAuth({
          url: this.$Api.userList,
          method: "get",
          data: {
            offset: (this.pageIndex - 1) * this.curPageSize,
            limit: this.curPageSize,
            store_id: form.store_id,
            start_time: this.$Utils.formatDate(form.start_time),
            end_time: this.$Utils.formatDate(form.end_time),
            username: form.username,
            phone: form.phone,
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 0) {
            let tempArr = [];
            let cabinet_name;
            let userversion;
            let userversion_time;
            let resData = res.data.data;

            for (let i = 0; i < resData.length; i++) {
              let integral_tw = 0;
              let cabinet_name = "- - -";
              if (resData[i].tw.length != 0) {
                for (let j = 0; j < resData[i].tw.length; j++) {
                  let integral_tw_count = Number(resData[i].tw[j].integral);
                  integral_tw += integral_tw_count;
                }
              }

              if (resData[i].useraddress[0] != null) {
                cabinet_name = resData[i].useraddress[0].ReceivingName;
              }

              if (resData[i].userversion[0] != null) {
                userversion = resData[i].userversion[0].version;

                if (resData[i].userversion[0].updated_at == null) {
                  userversion_time = "- - - - - - -";
                } else {
                  userversion_time = this.formatDate(
                    resData[i].userversion[0].updated_at
                  );
                }
              } else {
                userversion = "- - -";
                userversion_time = "- - - - - - -";
              }

              tempArr.push({
                user_id: resData[i].user_id,
                user_name: resData[i].user_name,
                phone: resData[i].phone,
                avatar: resData[i].avatar,
                status: resData[i].status,
                cabinet_name: cabinet_name,
                useraddress: resData[i].useraddress,
                userversion: userversion,
                user_integral: resData[i].user_integral,
                user_integral_tw: integral_tw,
                reg_time: resData[i].reg_time,
                jpoint: Number(resData[i].jpoint / 100),
                wx_openid: resData[i].wx_openid ? "有" : "沒有",
                cid: resData[i].cid ? "有" : "沒有",
                last_time: resData[i].last_time
                  ? resData[i].last_time
                  : "- - - - - - -",
                userversion_time: userversion_time,
              });
            }
            this.totalCount = res.data.count;
            this.table.data = tempArr;
          } else {
            this.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },

    handleSearch() {
      this.pageIndex = 1;
      this.getList();
    },

    handleEdit(index) {
      let tableData = this.table.data;
      this.$router.push({ path: "/userEdit?id=" + tableData[index].user_id });
    },
    handleIntegral(index) {
      let tableData = this.table.data;
      this.$router.push({
        path: "/userIntegral?id=" + tableData[index].user_id,
      });
    },
    handleDelete(index, status) {
      this.$Modal.confirm({
        title: "提示",
        content: "確定凍結嗎？",
        cancelText: "取消",
        okText: "確定",
        onOk: () => {
          let tableData = this.table.data;
          this.isSubmiting = true;

          this.$Rq
            .requestAuth({
              url: this.$Api.userDelete + "/" + tableData[index].user_id,
              method: "post",
              data: {
                status: status, //0启用, 1冻结
              },
            })
            .then((res) => {
              this.isSubmiting = false;

              if (res.code == 0) {
                this.$Utils.showSuccess(res.msg);

                this.pageIndex = 1;
                this.getList();
              } else {
                this.$Utils.showTipInfo(res.msg);
              }
            })
            .catch((err) => {
              this.isSubmiting = false;
            });
        },
      });
    },

    //pager
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      this.getList();
    },

    handlePageInput() {
      let value = ("" + this.pageInput).replace(/\D/g, "");
      let pageCount = Math.ceil(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == "" || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      this.getList();
    },

    handlePageChange(value) {
      this.pageIndex = value;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "UserList.scss";
</style>
